// Imports
import React from "react";
import { connect } from "react-redux";
import { withRouter, NavLink as Link, matchPath } from "react-router-dom";

// UI Imports TO - DO
import { Collapse, Navbar, NavbarToggler, NavbarBrand } from "reactstrap";

import ContainerFluid from "./../../../ui/ContainerFluid";

import LeftNav from "./ui/LeftNav";
import RightNav from "./ui/RightNav";
import RegisterNav from "./ui/RegisterNav";
import ChangePasswordNav from "./ui/ChangePasswordNav";

// App Imports
import userRoutes from "../../../setup/routes/user";
import userAuthRoutes from "../../../setup/routes/user-auth";
import adminRoutes from "../../../setup/routes/admin";

import {
  fetchUsers,
  resetUsersFiltersBar,
} from "../../admin/user/store/actions";
import { resetProgramFiltersBar } from "../../admin/programs/store/actions";

import { APP_VERSION } from "../../../setup/constants";

import Logo from "./images/logo.svg";
// styles
import "./styles/header.scss";
import Band from "../../admin/band/Band";
import AdminNav from "./ui/AdminNav";

// Component
const Header = (props) => {
  const {
    isAuthenticated,
    isUser,
    isSuperAdmin,
    isAdmin,
    isGuide,
    currentUser,
    location,
  } = props;

  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const onClickNavLink = (value) => {
    if (!value) return;
    const { from } = value;
    switch (from) {
      case adminRoutes.userList.name:
        if (props.history.location.pathname === adminRoutes.userList.path) {
          props.resetUsersFiltersBar(true);
        }
        break;
      case adminRoutes.programsList.name:
        if (props.history.location.pathname === adminRoutes.programsList.path) {
          props.resetProgramFiltersBar(true);
        }
        break;
      default:
        break;
    }

    isMenuOpen && setIsMenuOpen(false);
  };

  const signupPathMatch = matchPath(props.location.pathname, {
    path: [userAuthRoutes.completeSignup.path, userAuthRoutes.signup.path],
    strict: true,
  });
  const changePasswordPathMatch = matchPath(props.location.pathname, {
    path: userAuthRoutes.changePassword.path,
    strict: true,
  });

  return (
    <>
      {location.pathname === "/" && <Band />}
      <div className="lr-custom-navbar">
        <Navbar className="navbar" light expand="lg">
          <ContainerFluid>
            <NavbarBrand
              className="navbrand-color"
              to={userRoutes.home.path}
              tag={Link}
            >
              <div>
                <img
                  style={{ marginTop: -10, marginRight: 30 }}
                  src={Logo}
                  alt="logo"
                  width={"18%"}
                  height={"18%"}
                />
                La Ressourcerie <span> {APP_VERSION} </span>
              </div>
            </NavbarBrand>
            <NavbarToggler onClick={() => setIsMenuOpen(!isMenuOpen)} />
            <Collapse isOpen={isMenuOpen} navbar>
              {signupPathMatch && signupPathMatch.isExact ? (
                <RegisterNav
                  goBack={props.history.goBack}
                  onClickNavLink={onClickNavLink}
                />
              ) : changePasswordPathMatch && changePasswordPathMatch.isExact ? (
                <ChangePasswordNav />
              ) : (
                <>
                  <LeftNav
                    isAuthenticated={isAuthenticated}
                    isSuperAdmin={isSuperAdmin}
                    isAdmin={isAdmin}
                    isGuide={isGuide}
                    isUser={isUser}
                    onClickNavLink={onClickNavLink}
                  />
                  <RightNav
                    isAuthenticated={isAuthenticated}
                    isSuperAdmin={isSuperAdmin}
                    isAdmin={isAdmin}
                    isGuide={isGuide}
                    isUser={isUser}
                    avatarImg={currentUser && currentUser.avatar}
                    onClickNavLink={onClickNavLink}
                  />
                </>
              )}
            </Collapse>
          </ContainerFluid>
        </Navbar>
        {isAuthenticated && (isSuperAdmin || isAdmin || isGuide) && (
          <AdminNav onClickNavLink={onClickNavLink} />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => state.auth;

export default withRouter(
  connect(mapStateToProps, {
    fetchUsers,
    resetUsersFiltersBar,
    resetProgramFiltersBar,
  })(Header)
);
